import { IonContent, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonList, IonPage, IonToolbar, withIonLifeCycle } from "@ionic/react";
import { play } from "ionicons/icons";
import React from "react";
import YouTube from "react-youtube";
import { YoutubeDataAPI } from "youtube-v3-api";
import AcrofitHeader from "../components/AcrofitHeader";

const API_KEY = 'AIzaSyDanLSukjYxFrFQsa1mSen42yiuqOcI5ZM';

class VideoPage extends React.Component{

    state = { 
        items: [] as Array<any>,
        active:undefined as any,
        pageToken:"" as string
    }

    async ionViewDidEnter(){
        await this.refresh()
    }

    refresh = async () => {
        const api = new YoutubeDataAPI(API_KEY);
        const {items,nextPageToken} = await api.searchPlaylistItems("PLFMTKxJ7RbD1J2WRoSqnRaUqMv52GRRO5",15,{order:"date"}) as any
        if(items && items.length > 0){
            this.setState({items,pageToken:nextPageToken,active:items[0]})
        }
    }

    fetchData = async () => {
        const api = new YoutubeDataAPI(API_KEY);
        const response = await api.searchPlaylistItems("PLFMTKxJ7RbD1J2WRoSqnRaUqMv52GRRO5",15,{order:"date",pageToken:this.state.pageToken}) as any
        const {items,nextPageToken} = response
        this.setState({pageToken:nextPageToken,items:this.state.items.concat(items)})
    }

    render(){
        const {pageToken,items,active} = this.state
        return (
            <IonPage>
                <AcrofitHeader>
                    {
                        active && (
                            <IonToolbar>
                                <YouTube videoId={active.snippet.resourceId.videoId} opts={{width:"100%",height:"200px"}} />
                            </IonToolbar>
                        )
                    }
                </AcrofitHeader>
                <IonContent className="transparent">
                    <IonList className="no-bg">
                    {
                        items.map((video,k) => (
                            video?.snippet?.thumbnails?.high && (
                                <IonItem key={k} button onClick={() => this.setState({active:video})} className="no-bg">
                                    <img src={video?.snippet?.thumbnails?.high?.url} alt="" style={{width:100}} slot="start" />
                                    <small>{video.snippet.title}</small>
                                </IonItem>
                            )
                        ))
                    }
                    </IonList>
                    <IonInfiniteScroll disabled={!pageToken}
                        onIonInfinite={this.fetchData}>
                        <IonInfiniteScrollContent loadingText="Cargando más videos" />
                    </IonInfiniteScroll>
                </IonContent>
            </IonPage>
        )
    }
}

export default withIonLifeCycle(VideoPage)